module.exports = __webpack_public_path__ + "img/portifolio_Agro.8e233554.jpg";